import React, { useState, useEffect, useContext } from "react";
import {Helmet} from "react-helmet";
import {
	Link,
	useParams,
} from "react-router-dom";
import { TagsContext } from "../Components/Contexttags";
import { TagsEnContext } from "../Components/Contextentags";

const TitleinView = ({ title }) => {
	const options = {
		root: null,
		rootMargin: "0px",
		threshold: 1.0,
	};
	//const { ref, inView, entry } = useInView(options);
	return (
		<>
			<h2
				//ref={ref}
				/*className={"h1 " + (inView ? "active" : "")}*/
				className={"h1 " + ("active")}
				dangerouslySetInnerHTML={{ __html: title}}
			></h2>
		</>
	);
};
function Menutop({props}) {
	if (process.env.REACT_APP_POSTTYPE === 'posts') {
		return <>
			<div className={"site-header " +props}><nav className="site-header-i" itemScope itemType="http://schema.org/SiteNavigationElement">
			<Link className="nolink" to={"/"} >Blog</Link>
			<Link className="nolink" to={"/tag/epices/"} >Épices</Link>
			<Link className="nolink" to={"/tag/tisanes-et-thes/"} >Tisanes et Thés</Link>
			<Link className="nolink" to={"/tag/fruits-et-legumes/"} >Fruits et Légumes</Link>
			<Link className="nolink" to={"/tag/fitness/"} >Fitness</Link>
			</nav></div>
			</>
	} else if (process.env.REACT_APP_POSTTYPE === 'nutrition') {
		return <>
			<div className={"site-header " +props}><nav className="site-header-i" itemScope itemType="http://schema.org/SiteNavigationElement">
			<Link className="nolink" to={"/"} >Blog</Link>
			<Link className="nolink" to={"/tag/spices/"} >Spices</Link>
			<Link className="nolink" to={"/tag/herbal-teas/"} >Herbal teas and Teas</Link>
			<Link className="nolink" to={"/tag/fruits-and-vegetables/"} >Fruits and vegetables</Link>
			<Link className="nolink" to={"/tag/fitness/"} >Fitness</Link>
			</nav></div>
			</>
	} else {
		return <></>
	}
}
function Items({ posts, images }) {
  return (
    <>
      {posts &&
					posts.map((item) => (
					item.acf.featured === "" ? (
						<article key={item.id}>
							<Link className="nolink" to={"/blog/" + item.slug + "/"} >
								<TitleinView title={item.title.rendered}></TitleinView>
							</Link>
					{images && images.map((itemi) =>
					itemi.id == item.featured_media ? (
//<div key={item.link}></div>
					<img loading="lazy" key={itemi.id} src={itemi.guid.rendered}alt={item.title.rendered} />
					)
					:"")
					}
							
							<div
								className="content"
								dangerouslySetInnerHTML={{ __html: item.excerpt.rendered}}
							></div>
							<Link className="" to={"/blog/" + item.slug + "/"}>
								Lire
							</Link>
						</article>
					):("")
					))}
    </>
  );
}

export default function Tag() {
	//const [error, setError] = useState(null);
	//const [isLoaded, setIsLoaded] = useState(false);

//ReactGA.initialize(process.env.REACT_APP_ANALYTICS);

	/*const [posts, setPosts] = useState([]);
	//const PostsContext = React.createContext()

	useEffect(() => {
		//fetch("http://localhost:8080/api/posts/")
		fetch("https://www.ondevisuelle.fr/old2/wp-json/wp/v2/posts")
			.then((res) => res.json())
			.then(
				(result) => {
					setIsLoaded(true);
					setPosts(result);
				},
				// Remarque : il faut gérer les erreurs ici plutôt que dans
				// un bloc catch() afin que nous n’avalions pas les exceptions
				// dues à de véritables bugs dans les composants.
				(error) => {
					setIsLoaded(true);
					setError(error);
				}
			);
	}, []);

  */
	const { slug } = useParams();
	//const posts = useContext(PostsContext);
	//const images = useContext(ImagesContext);

const [isLoaded, setIsLoaded] = useState(false);
	const [posts, setPosts] = useState([]);
	const [images, setImages] = useState([]);
	//const posts = useContext(PostsContext);
	//const images = useContext(ImagesContext);


useEffect(() => {
const fetchContent = async () => {
    try {
      //...
return fetch("https://www.espace-bien-etre.fr/wp/wp-json/wp/v2/"+process.env.REACT_APP_POSTTYPE+"/?per_page=1000")

    } catch (err) {console.log(err)}
  };

  const fetchSectors = async (firstId) => {
    try {
      //...
//console.log(2)
return fetch("https://www.espace-bien-etre.fr/wp/wp-json/wp/v2/media/?per_page=1000")

    } catch (err) {console.log(err)}
  };

async function fetch1() {
  const res = await fetchContent(); // get data B first
  const data = await res.json();
  //console.log("Data at the beginning: ", data);

  const nextRes = await fetchSectors();
  const nextData = await nextRes.json();
//let nextData_array = [];
//nextData_array.push(nextData);

	setPosts(data);
	setImages(nextData);
  //console.log("Data at the end: ", nextData);
}
fetch1();

},[])
//if (process.env.REACT_APP_LANG_MAIN === 'en') {
//	const tagsen = useContext(TagsContextEn);
	//
	const tags = useContext(process.env.REACT_APP_LANG_MAIN === 'en' ? TagsEnContext : TagsContext);
//const posts = useContext(PostsContext);
	//console.log(tags);
	//            <img src="" className="header" alt={item.title.rendered} />
	//const codeString = item.title.rendered;
	return (
		<>
		{tags && 
		tags.map((itemt) => (
		itemt.slug === slug ? (
		images && images.map((itemi) =>
			itemi.id == itemt.acf.image ? (
		<Helmet>
			<title>{itemt.name}</title>
			<meta name="description" content={itemt.description} />
			<meta property="og:url" content={window.location.protocol + "//" + window.location.host + "/tag/" + itemt.slug + "/"} />
			<meta property="og:site_name" content={process.env.REACT_APP_TITLE} />
			<meta property="og:locale" content={process.env.REACT_APP_LANG} />
			<meta property="og:type" content="siteweb" />
			<meta property="og:title" content={itemt.name} />
			<meta property="og:image" content={itemi.guid.rendered} />
			<link rel="canonical" to={window.location.protocol + "//" + window.location.host + "/tag/" + itemt.slug + "/"} />
		</Helmet>
		):(""))
		):("")
		))}
		<Menutop></Menutop>
			{/*<Parallax
				bgImage={process.env.REACT_APP_HEADERBG}
				bgImageAlt=""
				strength={200}
				className="header_background"
			></Parallax>*/}
			
		{tags && 
		tags.map((itemt) => (
		itemt.slug === slug ? (
		images && images.map((itemi) =>
			itemi.id == itemt.acf.image ? (
			<div className="header_background"><img src={itemi.guid.rendered} alt={itemt.name} /></div>
		):('') ))
					:""))
					}
			<div className="main">
		{tags && 
		tags.map((itemt) => (
		itemt.slug === slug ? (
				<>
				<h1 className="h1_main" dangerouslySetInnerHTML={{__html:itemt.name}}></h1>
				<p>{itemt.description}</p>
				</>
		)
					:""))
					}
				{tags && 
		tags.map((itemt) => (
		itemt.slug === slug ? (
				posts &&
					posts.map((item) => (
					item.categorie?.includes(itemt.id) || item.categorie_en?.includes(itemt.id) ? (
						<article key={item.id}>
							<Link className="nolink" to={"/blog/" + item.slug + "/"} >
								<TitleinView title={item.title.rendered}></TitleinView>
							</Link>
							
					{images && images.map((itemi) =>
					itemi.id == item.featured_media ? (
//<div key={item.link}></div>
					<Link className="nolink" to={"/blog/" + item.slug + "/"} ><img loading="lazy" key={itemi.id} src={itemi.guid.rendered} alt={item.title.rendered} /></Link>
					)
					:"")
					}
						</article>
					):("")
					))
					

			):(""))) }
		{tags && 
		tags.map((itemt) => (
		itemt.slug === slug ? (
<p dangerouslySetInnerHTML={{__html:itemt.acf.contenu}}></p>
		):("")))}
			</div>
		<Menutop props="bas"></Menutop>
		</>
	)
}